import {
  submitAssignToCaoForm,
  useAssignToCoaForm,
} from "../accounting/useSystemWallets";
import { useFraudCasesForm } from "../fraud_detection/useFraudAlerts";
import { submitFraudCase } from "../submission/useModalSubmissions";
import { formHooks, formSubmitHooks } from "./useFormHandler";

export const modalFormHooks: Record<string, any> = {
  ...formHooks,
  fraud_cases: useFraudCasesForm,
  assign_to_coa: useAssignToCoaForm,
};

export const modalFormSubmitHooks: Record<string, any> = {
  ...formSubmitHooks,
  fraud_cases: submitFraudCase,
  assign_to_coa: submitAssignToCaoForm,
};
